// src/pages/NewsboardPage.js
import React from 'react';
import Newsboard from '../components/Newsboard/Newsboard';
import './NewsboardPage.css';

const NewsboardPage = ({ user, userProfile }) => {
  return (
    <div className="newsboard-page">
      <Newsboard user={user} userProfile={userProfile} />
    </div>
  );
};

export default NewsboardPage;